// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiPricingPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';

export interface NidPriceAvailabilityParams {
  nid?: string;
  country?: string;
}

export interface NidPriceAvailability {
  nid: string;
  current_state: number;
  is_available_price: boolean;
}

export const nidPriceAvailabilityEndpoints = apiPricingPortal.injectEndpoints({
  endpoints: builder => ({
    getNidPriceAvailability: builder.query<
      NidPriceAvailability,
      NidPriceAvailabilityParams
    >({
      query: ({ nid, country }) =>
        `/nid_price_availability?nid=${nid}&country=${country}`,
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getNidPriceAvailability',
        };
        return modelError;
      },
      transformResponse: (response: NidPriceAvailability) => response,
    }),
  }),
});

export const { useGetNidPriceAvailabilityQuery } =
  nidPriceAvailabilityEndpoints;
